import type {
  RetrofitFinancingCalculated,
  RetrofitFinancingResult,
} from '@/shared/types/retrofit-financing.types'
import { httpClient } from '@/shared/utils/http-client'

const DATA_CORE_API_BASE_URL = import.meta.env.DEV
  ? '/data-core-service/v3/building'
  : 'https://data-core-service.enter.de/v3/building'

class RetrofitFinancingApi {
  /**
   * Fetch retrofit financing data for a specific building
   * @param buildingId - The UUID of the building
   * @returns Promise with retrofit financing data
   */
  async getRetrofitFinancing(buildingId: string): Promise<RetrofitFinancingResult[]> {
    const url = `${DATA_CORE_API_BASE_URL}/${buildingId}/retrofit-financing`
    const response = await httpClient.get<RetrofitFinancingCalculated>(url)
    return response.results
  }
}

export const retrofitFinancingApi = new RetrofitFinancingApi()
